var offline_mode = false; // true or false
var user_group_id = "162";
var user_group_name = "";
//var user_group_ua_property_id = "UA-601294-24"; // GA Linker - Variable
//var user_group_ua_property_id = "UA-143763325-8"; // GA Linker - Variable - Cross Domain Tracking
var offline_url = "https://www.harveynormanphotos.com.au/pages/offline";
var reimagine_url = "https://162.app.fujifilmimagine.com/";
var poster_url = "https://162.app.fujifilmimagine.com/product/posters/";
//var domain_name = "rest.fujifilmimagine.com";

(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

ga('create', 'UA-XXXXX-Y', 'auto');
ga(function(tracker) {
  dataLayer.push({event:"ga_ready"});
}); 

function readCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
}

function getGaData() {  
    let linker_param;
    const dictionary_var = {};
    try {
        const _ga_streamid = '_ga_01VFLB3Q2Z';         
        const gaCookie = readCookie('_ga');
        if (gaCookie) {
            const _ga_var = gaCookie.split('.');
            const tmp = `${_ga_var[_ga_var.length - 2]}.${_ga_var[_ga_var.length - 1]}`;
            dictionary_var["_ga"] = tmp;
        } else {
            throw new Error("Cookie '_ga' NOT FOUND");
        }
        const gaStreamCookie = readCookie(_ga_streamid);
        if (gaStreamCookie) {
            const _ga_var2 = gaStreamCookie.split('.');
            dictionary_var[_ga_streamid] = `${_ga_var2.slice(2, 9).join('.')}`;
            console.log("GTM CC Output\n", dictionary_var);
            linker_param = window.google_tag_data.glBridge.generate(dictionary_var);
            console.log("GTM CC Output-\n", `?_gl=${linker_param}`);
        } else {
            throw new Error("Cookie '_ga_01VFLB3Q2Z' NOT FOUND");
        }       
    } catch (err) {
        console.log("Error occurred in Linker Parameter: ", err.message);
    }
    return linker_param ? `_gl=${linker_param}` : '';
}
// GA Linker - Function. This gets the _ga url paramter for cross-domain tracking
function getGALinker() {
	var linkerParam;
	try {
		if(typeof ga != 'undefined' && user_group_ua_property_id) {
			// live property ID
			var propertyID = user_group_ua_property_id;
			var targetTracker;
			var trackers = ga.getAll();
			for (var i = 0; i<trackers.length; i++) {
				// tracker is not null and has get function
				if (trackers[i] && typeof trackers[i].get != 'undefined') {
					// tracker property ID matches live property ID
					if (trackers[i].get('trackingId') == propertyID) {
						// set as target tracker
						targetTracker = trackers[i];
					}
				}
			}
			if (targetTracker) {
				// get linker paramater for url;
				linkerParam = targetTracker.get('linkerParam');
			}
		} else {
			// ga not defined
		}
	} catch (e) {
		// script error
	}
	return linkerParam;
}

function fullWin(imagine_id) {
	var win;

	// GA Linker - Attempt to get _ga
	var gaLink = '';
	if (typeof getGALinker != 'undefined' ) {
		var gaLinkResult = getGALinker();
		if (gaLinkResult && gaLinkResult.indexOf('_ga') >= 0) {
			gaLink = '?&'+gaLinkResult;
		}
	}

   var gaData ='';
  if (typeof getGaData !== 'undefined' ) {
    try {
		  gaData = getGaData();
    } catch(e) {
      gaData = '';
    }
  }
    
	//Mixpanel tracking
	if (typeof mixpanel !== 'undefined') {
		mixpanel.track('LANDING_IMAGINE_CLICKED');
	}

	// GA Linker - gaLink is added to redirect links
	if (offline_mode == true) {
		// offline mode
		window.location.href = offline_url + "?" + gaData;
	} else if (imagine_id == "#" || imagine_id == "" || imagine_id == undefined) {
		// imagine id hasn't been passed
		window.location.href = reimagine_url + "?" + gaData;
	} else if (imagine_id.slice(-1) == "#") {
		// product redirect for posters
		window.location.href = poster_url + imagine_id.slice(0,-1) + "?" + gaData;
	} else {
		// product redirect for reimagine
		window.location.href = reimagine_url + "product-redirect?productId=" + imagine_id + "&" + gaData;
	}
}

function getProductPrice(imagine_id, shopify_id) {
	fetch("https://rest.fujifilmimagine.com/api/product/" + imagine_id)
		.then(function(response) { return response.json(); })
		.then(function(data) {
			if (data.product && data.product[0] != undefined) {
				// api returned a result
				if (data.product[0].promo_price > 0 && data.product[0].price != data.product[0].promo_price) {
					// promo price exists
					var promoEl = document.getElementById('promo_' + shopify_id);
					var productEl = document.getElementById('product_' + shopify_id);
					var expiresEl = document.getElementById('expires_' + shopify_id);
					var priceDataEl = document.getElementById('price_data_' + shopify_id);
					var badgeEl = document.getElementById('offer_badge_' + shopify_id);

					if (promoEl) { promoEl.style.display = ''; promoEl.innerHTML = "&#36;" + data.product[0].price; }
					if (productEl) { productEl.innerHTML = "&#36;" + data.product[0].promo_price; productEl.classList.add("on-sale-wrapper"); }
					if (expiresEl) { expiresEl.style.display = ''; expiresEl.innerHTML = " ENDS " + data.product[0].promo_ends; }
					if (priceDataEl) { priceDataEl.classList.add('on-sale-wrapper'); }
					if (badgeEl) { badgeEl.style.display = ''; }
				} else {
					// no promo exists
					var promoEl = document.getElementById('promo_' + shopify_id);
					var productEl = document.getElementById('product_' + shopify_id);
					var expiresEl = document.getElementById('expires_' + shopify_id);
					var priceDataEl = document.getElementById('price_data_' + shopify_id);
					var badgeEl = document.getElementById('offer_badge_' + shopify_id);

					if (promoEl) { promoEl.style.display = 'none'; }
					// check if product price exists before overwriting
					if (data.product[0].price > 0 && productEl) {
						productEl.innerHTML = "&#36;" + data.product[0].price;
					}
					if (productEl) { productEl.classList.remove("on-sale-wrapper"); }
					if (expiresEl) { expiresEl.style.display = 'none'; }
					if (priceDataEl) { priceDataEl.classList.remove('on-sale-wrapper'); }
					if (badgeEl) { badgeEl.style.display = 'none'; }
				}
				sessionStorage.setItem("imagineid_" + imagine_id, JSON.stringify(data.product)); // stores product details to session for use by google tag manager
			}
		})
		.catch(function(error) {
			// fetch error
		});
}

function getDeliveryEstimate(postcode) {
	fetch("https://rest.fujifilmimagine.com/api/delivery/" + postcode)
		.then(function(response) { return response.json(); })
		.then(function(data) {
			if (data.delivery && data.delivery[0] != undefined) {
				// api returned a result
				var formEl = document.getElementById('delivery_form');
				var submitEl = document.getElementById('delivery_submit');
				var regionEl = document.getElementById('delivery_region');
				var instoreEl = document.getElementById('delivery_instore');
				var standardEl = document.getElementById('delivery_standard');
				var expressEl = document.getElementById('delivery_express');
				var deliveryEl = document.getElementById('delivery');

				if (formEl) formEl.style.display = 'none';
				if (submitEl) submitEl.style.display = '';
				if (regionEl) regionEl.innerHTML = data.delivery[0].suburb + " " + postcode + ", " + data.delivery[0].state;
				if (instoreEl) instoreEl.innerHTML = data.delivery[0].instore;
				if (standardEl) standardEl.innerHTML = data.delivery[0].standard;
				if (expressEl) expressEl.innerHTML = data.delivery[0].express;
				if (deliveryEl) deliveryEl.style.display = '';
			}
		})
		.catch(function(error) {
			// fetch error
		});
}

// Attempts to retrieve the product name from the session storage
function getImagineName(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		result = pa[0].name;
	}
	return result;
}

// Attempts to retrieve the product category from the session storage
function getImagineCat(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		result = pa[0].category;
	}
	return result;
}

// Attempts to retrieve and calculate the current price from the session storage
function getImaginePrice(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		result = pa[0].price;
	}
	return result;
}

// Attempts to retrieve and calculate the current price from the session storage
function getImaginePromoPrice(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		if (pa[0].promo_price > 0) {
			result = pa[0].promo_price;
		} else {
			result = pa[0].price;
		}
	}
	return result;
}

// Attempts to determine if product is on promo from the session storage
function isOnPromo(imagine_id) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = 'False';
	} else {
		if (pa[0].promo_price > 0) {
			result = 'True';
		} else {
			result = 'False';
		}
	}
	return result;
}

// Retrieve product details from Shopify for a specific SKU
function getLastOrder() {
	fetch("https://rest.fujifilmimagine.com/api/lastorder/" + user_group_id)
		.then(function(response) { return response.json(); })
		.then(function(data) {
			if (data.order && data.order[0] != undefined) {
				// api returned a result
				if (data.order[0].product_id != "") {
					var whereEl = document.getElementById('popup_where');
					var whenEl = document.getElementById('popup_when');
					if (whereEl) whereEl.innerHTML = data.order[0].suburb;
					if (whenEl) whenEl.innerHTML = data.order[0].timesince;
					getShopifyProduct(data.order[0].product_id);
					var popupBtn = document.querySelector('.openPopupOrders');
					if (popupBtn) popupBtn.click();
				}
			}
		})
		.catch(function(error) {
			console.log(error);
		});
}

// Retrieve product details from Shopify for a specific SKU
function getShopifyProduct(imagine_id) {
	fetch("/search?type=product&view=sku&q=sku:" + imagine_id)
		.then(function(response) { return response.json(); })
		.then(function(data) {
			if (data.products && data.products[0] != undefined) {
				// api returned a result
				if (data.products[0] != "") {
					var linkEl = document.getElementById('popup_link');
					var imgEl = document.getElementById('popup_image');
					if (linkEl) { linkEl.setAttribute("href", data.products[1]); linkEl.innerHTML = data.products[2]; }
					if (imgEl) { imgEl.setAttribute("src", data.products[3]); }
				}
			}
		})
		.catch(function(error) {
			console.log(error);
		});
}


